export default __webpack_public_path__ + "static/media/stand-out-as-a-developer-luke-chesser-min.ec97ccdf.jpg";